<template>
    <div class="ms-style1" v-if="isShow">
        <div class="htop" v-if="imgMap1&&imgMap1.id" @click="toLink(imgMap1)">
            <img :src="imgMap1.adImgUrl" class="mst-img">
        </div>
        <div class="htop1" v-if="imgMap2&&imgMap2.id" @click="toLink(imgMap2)">
            <img :src="imgMap2.adImgUrl" class="mst-img">
        </div>
        <div class="qbtm">
            <div class="qbtm-left" @click="toLink(imgMap3)" v-if="imgMap3&&imgMap3.id">
                <img :src="imgMap3.adImgUrl"  class="mst-img">
            </div>
            <div class="qbtm1">
                <div class="qbtm-right" @click="toLink(imgMap4)" v-if="imgMap4&&imgMap4.id">
                    <img :src="imgMap4.adImgUrl"  class="mst-img">
                </div>
                <div class="qbtm-right1" @click="toLink(imgMap5)" v-if="imgMap5&&imgMap5.id">
                    <img :src="imgMap5.adImgUrl"  class="mst-img">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        data() {
            return {
                deptId: '',
                imgMap1: {},
                imgMap2: {},
                imgMap3: {},
                imgMap4: {},
                imgMap5: {},
                isShow:false,
            };
        },
        props: {
            imgMap: Object
        },
        async created() {
            if (this.imgMap.one) {
                this.imgMap1 = this.imgMap.one
                this.isShow=true
            }
            if (this.imgMap.two) {
                this.imgMap2 = this.imgMap.two
                this.isShow=true
            }
            if (this.imgMap.three) {
                this.imgMap3 = this.imgMap.three
                this.isShow=true
            }
            if (this.imgMap.four) {
                this.imgMap4 = this.imgMap.four
                this.isShow=true
            }
            if (this.imgMap.five) {
                this.imgMap5 = this.imgMap.five
                this.isShow=true
            }
            this.deptId = getDeptId()
        },

        methods: {
            toLink(item) {
                if (item.adLink) {
                    this.$router.push(item.adLink)
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .ms-style1 {
        margin-bottom: 15px;
    }

    .htop {
        width: 100%;
        margin-bottom: 5px;
    }

    .htop1 {
        width: 100%;
    }
    .qbtm {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .mst-img {
        width: 100%;
        height: 100%;
    }

    .qbtm1 {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 49%;
    }

    .qbtm-left {
        width: 49%;
    }

    .qbtm-right {
        width: 100%;
        height: 110px;
        margin-bottom: 5px;
    }

    .qbtm-right .mst-img {
        width: 100%;
        height: 110px;
    }

    .qbtm-right1 {
        width: 100%;
        height: 110px;
    }

    .qbtm-right1 .mst-img {
        width: 100%;
        height: 110px;
    }

</style>
